import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/team/Suparna.png";

function IntervjuSuparna() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.interviewSuparna.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.interviewSuparna.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/intervju-suparna"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.interviewSuparna.title")}
          </h1>
          <p className="text-xl mb-2">
          {i18next.t("pages.articles.list.interviewSuparna.sections.intro")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.interviewSuparna.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5">
          <img
            src={article_img}
            className="w-full"
            alt={i18next.t("pages.articles.list.interviewSuparna.imageAlt")}
          />
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.intro2")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewSuparna.sections.workday.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.workday.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.workday.content2")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewSuparna.sections.motivation.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.motivation.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.motivation.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.motivation.content3")}</p>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewSuparna.sections.customerEase.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.customerEase.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.customerEase.content2")}</p>
            <p>{i18next.t("pages.articles.list.interviewSuparna.sections.customerEase.content3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewSuparna.sections.challenges.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.challenges.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.challenges.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.challenges.content3")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.challenges.content4")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewSuparna.sections.feedback.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.feedback.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewSuparna.sections.aiFuture.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.aiFuture.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.aiFuture.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.aiFuture.content3")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.aiFuture.content4")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewSuparna.sections.team.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.team.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.team.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.team.content3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewSuparna.sections.creativity.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewSuparna.sections.creativity.content")}</p>

            <p className="mt-6 font-bold">
              {i18next.t("pages.articles.list.interviewSuparna.sections.closing")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntervjuSuparna;


